import $ from 'jquery';
import { modelServices } from '@/app/shared/services/client-agent-service.js';
import { KendoService } from '@/app/shared/services/kendo-service/kendoService.js';
import kendo from '@progress/kendo-ui';
import { noRecordTemplate, getTooltipTilte, preventFilterAutocomplete } from '@/app/shared/grid-functionality/grid-functionality.js';
//import { getGridSelectedObj } from '@/app/shared/grid-functionality/grid-utilities.js';
import { EventBus } from '@/app/shared/services/event-bus.js';
import { manufacturingOrderService } from '@/app/inventory-management/shared/services/inventory-management/manufacturing-order-service.js';
import ConfirmPopup from '@/app/shared/components/confirm-popup/confirm-popup.vue';
import localeEn from '../../../../locales/en'
import localeAr from '../../../../locales/ar'
import config from '@/app/inventory-management/shared/config/inventory-management-config.json';

let gridFields = {
    CodePrefix: { type: "string" },
    WarehouseName: { type: "string" },
    CreatedDate: { type: "date" }
};

let data = new KendoService(manufacturingOrderService.getManufacturingOrders(), config.pageSize, 'ID', gridFields, '_CreatedDate');

export default {
    name: 'ManufacturingOrder-list',
    data() {
        return {
            condAdd: this.showHideElement("Add"),
            filterableObject: {
                mode: 'row',
                extra: 'false',
                messages: {
                    search: true
                },
                operators: {
                    string: 'contains'
                }
            },
            customGridCommand: [
                {
                    name: "view",
                    text: this.$i18n.t('Common.View'),
                    click: this.viewData,
                    template: `<a role='button' class='k-button k-button-icontext  k-grid-view' > ${this.$i18n.t('Common.View')} <img src=${require('@/assets/svg/ViewIcon.svg')} /></a>`
                }
            ],
            datasource: data.data,
            confirmdata: [
                {
                    iconName: '',
                    confirmText: '',
                    confirmBtnBtnText: '',
                    cancelBtnText: '',
                    headerTitle: '',
                    messageText: '',
                    itemName: '',
                    id: '',
                    modifiedTs: ''
                }
            ],
            dateFormatForGrid: config.dateGridFormat,
        }
    },
    methods: {
        showHideElement(clientAction) {
            return modelServices.ifUserHasPermission(clientAction, this.$route.name);
        },
        noRecordTemplate,
        getTooltipTilte: e => getTooltipTilte(e),
        onDataBound: function (e) {

            preventFilterAutocomplete(e);
        },
        showPopupNotification: function (msg, type) {
            this.popupNotificationWidget.show(msg, type);
        },
        dateTemplate(args) {
            args.element.kendoDatePicker({
                format: config.dateFormat
            });
        },
        generateAddBtn() {
            let templateHtml; 
            if (this.condAdd) {
                templateHtml = `<a role="button" class="k-button k-button-icontext k-grid-add">
                                        <span class="k-icon k-i-plus"></span>
                                       ${this.$i18n.t('Inventory.ManufacturingOrder')}
                                </a>`;
            } else {
                templateHtml = ``;

            }
            return kendo.template(templateHtml);

        },
        viewData(e) {
             
            let grid = $("#MOGrid").getKendoGrid();
            let item = grid.dataItem($(e.target).closest("tr"));

            this.$store.commit('updateIsViewMO', true)
            this.$store.commit('updateMOID', item.ID);
            
            this.$router.push('/supply-chain/inventory-management/inventory-operations/manufacturing-orders/view-manufacturing-order');
            
        },
    },
    beforeDestroy() {
        const gridElement = this.$refs.ManufacturingOrderGrid.kendoWidget().element;
        const toolbarElement = gridElement.find('.k-grid-toolbar');
        toolbarElement.off("click");

        EventBus.$off('confirmed-action')
    },
    i18n: {
        messages: {
            en: {
                ...localeEn
            },
            ar: {
                ...localeAr
            }
        },
    },
    components: {
        ConfirmPopup
    },
    directives: {

    },
    mounted: function () {
        this.popupNotificationWidget = this.$refs.popupNotificationSave.kendoWidget();

        $('.k-filtercell [data-role="autocomplete"] ,.k-filtercell [data-role="numerictextbox"]').attr('placeholder', '');

        // add btn handling
        document.querySelector(".ManufacturingOrder-list").addEventListener('click', (e) => {
            if (e.target && e.target.classList.contains("k-grid-add")) {
                this.$router.push('/supply-chain/inventory-management/inventory-operations/manufacturing-orders/new-manufacturing-order');
            }
        });

        //  permissions
        if (!this.condAdd) $('.k-grid-add').remove();
    }
};				
